module.exports = __webpack_public_path__ + "img/iso_9001_27001.839a2989.svg";